<template>
    <div class="offcanvas-container">
        <div class="buttons--off-canvas"
             :class="{ 'is--open-btn': open, 'is--collapsed-btn': ! open }">
            <a href="#close-extraxtor-menu"
               class="btn is--center is--small close--off-canvas"
               @click.prevent="closeOffcanvasMenu"
               v-if="open">
                <i class="icon--arrow-left"></i>
            </a>

            <a href="#open-extraxtor-menu"
               class="btn is--center is--small open--off-canvas"
               @click="openOffcanvasMenu"
               v-else>
                <i class="icon--arrow-right"></i>
            </a>
        </div>

        <div class="container--ajax-cart off-canvas is--right is--active" :class="{ 'is--open': open, 'is--collapsed': ! open }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            open: {
                type: Boolean,
                default: false
            },
            configuration: {
                type: Object,
                default: () => { return {}; }
            }
        },

        methods: {
            openOffcanvasMenu() {
                this.open = true;
            },

            closeOffcanvasMenu() {
                this.open = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/components/offcanvas";
</style>



// WEBPACK FOOTER //
// src/components/Offcanvas.vue